import logo from './logo.svg';
import './App.css';
import AppHeader from './componenents/Header';
import AppFooter from './componenents/Footer';
import { Layout, Row, Col } from 'antd';
import BuildingList from './componenents/BuildingList';
import HeroSection from './componenents/HeroSection';
import LoginForm from './componenents/Forms/LoginForm';
import AppRoutes from './routes';
import { ApolloProvider } from '@apollo/client';
import client from './services/ApolloClient'; 
import React, { useEffect } from 'react'; // Removed useState as it wasn't being used here

const { Content } = Layout;

function App() {
  // ✅ The useEffect MUST be inside the function body
  useEffect(() => {
    const handleMessage = (event) => {
      // Replace with the actual origin of your first website
      // If your first site is on port 3000, keep this as is.
      const trustedOrigin = 'https://probono.ebosrndportal.com';

      if (event.origin !== trustedOrigin) return;

      if (event.data.type === 'connectedInHmi') {
        const email = event.data.email;
        if (email) {
          localStorage.setItem('connectedInHmi', email);
          console.log("Email saved to storage:", email);
          // ✅ ADD THIS: Notify other components that login data is ready
        window.dispatchEvent(new Event('hmi-login-ready'));
        }
      }
    };

    window.addEventListener('message', handleMessage);
    
    // Cleanup to prevent memory leaks or duplicate listeners
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="App">
      <ApolloProvider client={client}>
        <AppRoutes />
      </ApolloProvider>
    </div>
  );
}

export default App;